import { render, staticRenderFns } from "./leave-request-information.vue?vue&type=template&id=5c060bb4&scoped=true&"
import script from "./leave-request-information.vue?vue&type=script&lang=js&"
export * from "./leave-request-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c060bb4",
  null
  
)

export default component.exports